var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card", class: _vm.cls }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _vm._t("close"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-title" },
          [_vm._t("header"), _vm._v(" "), _vm._t("sub-header")],
          2
        ),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cf5596b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf5596b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/cards/CardBasic.vue
// module id = 465
// module chunks = 0